import type { ReactNode } from "react";

/** Overrides for when "Cancel"/"Confirm" would read badly. */
export type ConfirmLabels = {
  confirmLabel?: string;
  cancelLabel?: string;
};

export type DialogService = {
  alert: (message: ReactNode, title?: string) => Promise<boolean>;
  confirm: (
    message: string,
    title?: string,
    labels?: ConfirmLabels,
  ) => Promise<boolean>;
};

declare global {
  interface Window {
    dialogService?: DialogService;
  }
}

/** Replaces native window.alert with a custom dialog. */
export async function alert(
  message: ReactNode,
  title?: string,
): Promise<boolean> {
  if (window.dialogService?.alert) {
    return window.dialogService.alert(message, title);
  }

  window.alert(String(message));
  return true;
}

/** Replaces native window.confirm with a custom dialog. */
export async function confirm(
  message: string,
  title?: string,
  labels?: ConfirmLabels,
): Promise<boolean> {
  if (window.dialogService?.confirm) {
    return window.dialogService.confirm(message, title, labels);
  }

  // Fixed OK/Cancel buttons, so `labels` is dropped.
  return window.confirm(message);
}
